export const labels_hr = {
  applicationNameLong: "Knowledge Management",
  applicationNameShort: "KM",
  username: "Korisničko ime",
  password: "Lozinka",
  passwordPlaceholder: "Unesite lozinku",
  confirmPassword: "Potvrdite lozniku",
  login: "Prijava",
  needAccount: "Trebaš račun?",
  register: "Registriraj se",
  registration: "Registracija",
  logout: "Odjava",
  home: "Početna",
  all: "Svi",
  search: "Pretraga",
  name: "Naziv",
  namePlaceholder: "Unesite naziv",
  uriPlaceholder: "Unesite URI",
  institutionPlaceholder: "Unesite ustanovu",
  id: "ID",
  description: "Opis",
  descriptionPlaceholder: "Unesite opis",
  closeButton: "Zatvori",
  saveButton: "Spremi",
  comments: "Komentari",
  commentBox: "Napiši poruku...",
  comment: "Komentiraj",
  fullName: "Ime i prezime",
  previous: "Prethodno",
  next: "Slijedeće",
  submit: "Potvrdi",
  cancel: "Odustani",
  pageNotFound: "Stranica nije pronađena",
  welcome: "Dobrodošli",
  administration: "Administracija",
  knowledgeManagement: "Baza znanja",
  classification: "Poslovna klasifikacija",
  adminClassification: "Administracija poslovne klasifikacije",
  classificationType: "Tip poslovne klasifikacije",
  classificationStatus: "Status poslovne klasifikacije",
  addButton: " Dodaj",
  deleteButton: " Obriši",
  deleteButtonDescription: "Obriši označene retke",
  code: "Kod",
  codePlaceholder: "Unesite kod",
  dateFrom: "Datum od",
  dateFromPlaceholder: "Unesite datum od",
  dateFromTo: "Datum (od-do)",
  dateTo: "Datum do",
  dateToPlaceholder: "Unesite datum do",
  statusPlaceholder: "Odaberite status",
  typePlaceholder: "Odaberite tip",
  generalData: "Opći podaci",
  classificationModel: "Model poslovne klasifikacije",
  chooseModel: "Odaberite model",
  noData: "Nema podataka",
  descriptionUsage: "Opis upotrebe",
  saved: "Spremljeno",
  deleted: "Obrisano",
  knowledgeType: "Vrsta znanja",
  knowledgeCopyright: "Copyright",
  knowledgeItem: "Jedinica znanja",
  knowledgeSource: "Izvor znanja",
  state: "Stanje",
  states: "Stanja",
  knowledgeSourceClassification: "Klasifikacija izvora znanja",
  lifeCycle: "Životni ciklus",
  lifeCycleStateType: "Tip stanja životnog ciklusa",
  lifeCycleChangedBy: "Postavio životni ciklus",
  changedBy: "Promijenio",
  recordedBy: "Zapisao",
  modifiedBy: "Zadnji promijenio",
  partyInformation: "Informacije o sudionicima",
  note: "Zabilješka",
  uri: "URI",
  tags: "Tagovi",
  tag: "Tag",
  expand: "Proširi",
  selectedClassifications: "Odabrane poslovne klasifikacije",
  chooseClassification: "Odaberite poslovnu klasifikaciju",
  additionalData: "Dodatni podatci",
  documents: "Dokumenti",
  documentsUpdate: "Ažuriranje informacija dokumenta",
  contentType: "Vrsta dokumenta",
  dateCreated: "Datum kreiranja",
  areYouSureDelete: "Jeste li sigurni da želite obrisati ovaj dokument?",
  no: "Ne",
  yes: "Da",
  actions: "Akcije",
  upload: "Upload",
  selectFiles: "Odaberite datoteke",
  selectedFilesNum: "datoteka",
  knowledge: "Znanje",
  previousLifeCycle: "Prošlo stanje",
  currentLifeCycle: "Trenutno stanje",
  date: "Datum",
  ratings: "ocjena",
  rateNow: "Ocijeni",
  myRating: "Moja ocjena",
  institution: "Ustanova",
  messageLog: "Poruke",
  message: "Poruka",
  details: "Detalji",
  selectedKnowledgeSource: "Odabrani izvor znanja",
  messageLogType: "Vrsta poruke",
  lifeCycleClassDefinitions: "Definicije klasa životnih ciklusa",
  lifeCycleClassDefinition: "Definicija klasa životnih ciklusa",
  possibleNextStates: "Moguća sljedeća stanja",
  selectedNextStates: "Odabrana sljdeća stanja",
  lifeCycleTransitions: "Prijelazi stanja",
  partyRoles: "Role sudionika",
  roleTypes: "Vrste rola",
  partyRoleTypeDiscriminatorPlaceholder: "Odaberite diskriminator",
  roleType: "Vrsta role",
  involvementRoleTypePlaceholder: "Odaberite vrstu ovlasti",
  extensions: "Ekstenzije",
  individuals: "Korisnici",
  firstName: "Ime",
  lastName: "Prezime",
  email: "E-pošta",
  individual: "Korisnik",
  roleTypeName: "Naziv vrste role",
  partyRole: "Rola sudionika",
  roleTypePlaceholder: "Odaberite vrstu role",
  involvementRole: "Ovlast",
  involvementRoleTypes: "Vrste ovlasti",
  involvementRoleType: "Vrsta ovlasti",
  partyRoleTypeDiscriminator: "Diskriminator",
  sendMessage: "Pošalji",
  advancedSearchPlaceholder: "Unesite riječi",
  advancedSearch: " Napredna pretraga",
  correctWords: "Točne riječi",
  anyWords: "Bilo koja od tih riječi",
  nonWords: "Niti jedna od tih riječi",
  phrases: "Fraze",
  resetAdvancedSearchParams: "Poništi",
  advancedSearchDescription: "Riječi odvojiti zarezom",
  isAlreadySelected: "je već bila odabrana",
  isAdded: "je dodana",
  isRemoved: "je uklonjena",
  status: "Status",
  type: "Vrsta",
  parent: "Roditelj",
  parentPlaceholder: "Odaberite roditelja",
  active: "Aktivni",
  inactive: "Neaktivni",
  advancedSearchParamsDelete: "Obriši parametre napredne pretrage",
  classificationDetail: "Detalji poslovne klasifikacije",
  parentInvolvementRoleTypes: "Naslijeđene vrste ovlasti",
  atTime: ", u vremenu: ",
  rating: "Ocjena",
  backButton: "Natrag",
  newTab: "Otvori u novoj kartici",
  reactivateItem: "Vrati u rad",
  operations: "Operacije",
  involvementRoles: "Ovlasti",
  partiesAndSecurity: "Sudionici i sigurnost",
  entities: "Entiteti",
  deleteItem: "Obriši",
  settings: "Postavke",
  language: "Jezik",
  documentsContent: "Sadržaj dokumenata",
  searchQueryPlaceholder: "Unesite upit pretrage",
  searchResultHeader: "Rezultati pretrage",
  mostPopularTags: "Najpopularniji tagovi",
  myContribution: "Moj doprinos",
  mostPopularClassifications: "Najpopularnije poslovne klasifikacije",
  quickCreate: "Brzo kreiranje",
  documentEntryForm: "Unos dokumenata",
  uploadClickDragPlaceholder: "Kliknite ili povucite prilog za dodavanje",
  file: "Datoteka",
  document: "Dokument",
  KnowledgeItemCreate: "Unos jedinice znanja",
  system: "Sustav",
  searchSettings: "Postavke ES pretrage",
  startIndexing: "Pokretanje indeksiranja",
  startIndexingTooltip: "Pokreni indeksiranje Elastic Search pretrage",
  ok: "U redu",
  startIndexingModalBody:
    "Pokretanjem indeksiranja ES pretraga će privremeno biti nedostupna. Jeste li sigurni da želite pokrenuti indeksiranje?",
  startIndexingModalHeader: "Pokretanje indeksiranja",
  startIndexingAlert: "Indeksiranje je započelo",
  indexingStatus: "Status indeksiranja",
  subscriptions: "Pretplate",
  notifications: "Obavijesti",
  application: "Aplikacija",
  webBrowser: "Web-preglednik",
  classificationSubscriptions: "Pretplate na poslovne klasifikacije",
  classificationNotifications: "Obavijesti o poslovnim klasifikacijama",
  partyMessageDetailTitle: "Obavijest",
  read: "Pročitano",
  title: "Naslov",
  content: "Sadržaj",
  dispatchDate: "Datum slanja",
  partyMessagesTitle: "Obavijesti",
  entityLink: "Link do jedinice znanja",
  markAsRead: "Označi kao pročitano",
  markAsUnread: "Označi kao nepročitano",
  entityRelationshipTypes: "Vrste veza entiteta",
  entityRelationshipType: "Vrsta veze entiteta",
  relationCardinalityType: "Vrsta relacije",
  notificationBadgeMessage: "Nepročitane poruke",
  allMessages: "Sve poruke",
  entityRelationshipRelated: "Povezani entiteti",
  open: "Otvori",
  entityRelationShip: "Veza entiteta",
  entity: "Entitet",
  relatedEntity: "Vezani entitet",
  relatedEntities: "Vezani entiteti",
  unreadMessages: "Nepročitane poruke",
  chooseEntity: "Odaberite entitet",
  chooseEntityPlaceholder: "Odaberite entitet",
  reindexAllTitle: "Reindeksiranje svih entiteta",
  reindexOneTitle: "Reindeksiranje odabranog entiteta",
  numberOfRatings: "Broj ocjena: ",
  myRate: "Moja ocjena",
  searchable: "Pretraživo",
  deactivate: "Deaktiviraj",
  edit: "Uredi",
  urlCopied: "Url je kopiran u međuspremnik.",
  shareViaMailSubject: "Pogledaj ovaj link",
  similarKnowledgeItem: "Slična jedinica znanja",
  moreLabel: "Više...",
  information: "Informacije",
  help: "Pomoć",
  reportToC2S2: "Prijavite grešku na C2S2",
  refreshPage: "Osvježite stranicu",
  backToHome: "Povratak na početnu stranicu",
  mostPopularKnowledgeItems: "Popularne jedinice znanja",
  withAttachment: "Sadržaj dokumenta",
  chooseKnowledgeType: "Odaberite vrstu znanja",
  chooseClassificationTypePlaceholder: "Odaberite vrstu poslovne klasifikacije",
  classificationTypes: "Tipovi poslovne klasifikacije",
  chooseKnowledgeSource: "Odaberite izvor znanja",
  applicationCekom: "CIP4SI",
  initializing: "Postavljanje",
  loading: "Učitavanje",
  autoTags: "Automatski tagovi",
  addTag: "Dodaj tag",
  addToTag: "Dodaj tagovima",
  removeFromTags: "Obriši iz tagova",
  shareWithMail: "Pošalji link putem e-pošte",
  shareWithWhatsApp: "Pošalji link putem WhatsAppa",
  shareWithViber: "Pošalji link putem Vibera",
  copyLink: "Kopiraj link",
  similarKnowledgeItems: "Slične jedinice znanja",
  addToRelationship: "Dodaj vezu za jedinicu znanja",
  showSimilarDocuments: "Prikaži slične dokumente",
  similarDocuments: "Slični dokumenti",
  recommended: "Preporuka",
  organisations: "Grupe",
  documentType: "Vrsta dokumenta",
  documentTypeLink: "Poveznica",
  documentTypeFile: "Datoteka",
  documentLinkPreview: "URL za prikaz",
  documentLinkDownload: "URL za preuzimanje",
  documentLinkDuration: "Trajanje (s)",
  documentLinkSize: "Veličina (B)"
};
